import React, { useState, useRef, useEffect } from 'react';
import State from "../State";
import RegisteredListService  from "./RegisteredListService";
import './RegisteredList.css';

function RegisteredList({jsonServer}) {

    const [state] = useState(new State(useState(0)));
    let componentRefs = useRef([]);

    const service = new RegisteredListService(jsonServer, state);

    useEffect(() => {
        service.fetchRunners()
    }, []);

    if (state.loading) {
        return (
            <div>
                Hämtar anmälningar ...
            </div>
        );
    }

    const setSorting = (attribute, direction, attributeType) => {
        state.setSortingDirection(direction);
        state.setSorting(attribute);
        state.setSortingAttributeType(attributeType);
    }


    const runners = service.sortRunners();

    return (
        <div>
            <button title="Uppdatera" onClick={() => {service.fetchRunners();}}>🔄</button>
            <h1>Anmälda</h1>

            <div className="listregistrations">
                <table className="listregistrationtable">
                    <thead>
                    <tr key="registrationlist-header">
                        <th><span className={'sortingLink'} onClick={() => {
                            setSorting('lastName', 'asc', 'string')
                        }}>🔺</span>
                            <span className={'sortingLink'} onClick={() => {
                                setSorting('lastName', 'desc', 'string')
                            }}>🔻</span><br/>
                            Namn
                        </th>
                        <th><span className={'sortingLink'} onClick={() => {
                            setSorting('club', 'asc', 'string')
                        }}>🔺</span>
                            <span className={'sortingLink'} onClick={() => {
                                setSorting('club', 'desc', 'string')
                            }}>🔻</span><br/>
                            Ort/Förening
                        </th>
                        <th><span className={'sortingLink'} onClick={() => {
                            setSorting('team', 'asc', 'object')
                        }}>🔺</span>
                            <span className={'sortingLink'} onClick={() => {
                                setSorting('team', 'desc', 'object')
                            }}>🔻</span><br/>
                            Lag
                        </th>
                        <th><span className={'sortingLink'} onClick={() => {
                            setSorting('competitionClass', 'asc', 'object')
                        }}>🔺</span>
                            <span className={'sortingLink'} onClick={() => {
                                setSorting('competitionClass', 'desc', 'object')
                            }}>🔻</span><br/>
                            Klass
                        </th>
                        <th><span className={'sortingLink'} onClick={() => {
                            setSorting('bus', 'asc', 'bool')
                        }}>🔺</span>
                            <span className={'sortingLink'} onClick={() => {
                                setSorting('bus', 'desc', 'bool')
                            }}>🔻</span><br/>
                            Buss
                        </th>
                        <th><br/>
                            Betalt
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {runners.map(runner => (runner.status === 'Borttagen' ? '' :
                        <tr className={"registrationlistrow"} key={runner.id}>
                            <td>{runner.firstName} {runner.lastName}</td>
                            <td>{runner.club}</td>
                            <td>{runner.team ? runner.team.name : ''}</td>
                            <td>{runner.competitionClass ? runner.competitionClass.name : ''}</td>
                            <td>{runner.bus ? 'Ja' : 'Nej'}</td>
                            <td>{runner.status === 'Anmäld' ? 'Ja' : 'Nej'}</td>
                        </tr>))}
                    </tbody>

                </table>
            </div>

        </div>
    );
}

export default RegisteredList;